/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate, useParams } from "react-router";
import { ReactComponent as LeftArrow } from "../../assets/icons/arrows/left-arrow.svg";
import { PrimaryButton } from "../../components";
import { useEffect, useMemo, useState } from "react";
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { useTomraDrops } from "../../store/useTomraDrops";
import { tomraCanTypes } from "../../utils/tomraCanTypes";
import { useStatiegeldProducts } from "../../store/useStatiegeldProducts";

interface IRegroupedTomraItems {
  superGroup: number;
  barcode: string;
  count: number;
  totalRefund: number;
}

function TomraDropDetailsScreen() {
  /** Hooks */
  const navigate = useNavigate();
  const params = useParams();
  const { getOneTomraDrop, oneTomraDrop } = useTomraDrops();
  const { getStatiegeldProducts, statiegeldProducts } = useStatiegeldProducts();
  /** State */
  const [totalPrice, setTotalPrice] = useState(0);

  /** Effects */
  useEffect(() => {
    getStatiegeldProducts(1, 1000);
    if (!params?.id) return;
    getOneTomraDrop(params?.id);
  }, [params?.id]);

  useEffect(() => {
    setTotalPrice(oneTomraDrop?.refund ?? 0);
  }, [oneTomraDrop]);

  /** Callbacks */
  const goBack = () => navigate(-1);

  // const approveDrop = () => {
  //   const body = { status: "approved" };
  //   // @ts-ignore
  //   updateDrop(oneDrop?._id as string, body);
  // };
  // const holdDrop = () => {
  //   const body = { status: "pending", dropComposition: dropCompositions };
  //   // @ts-ignore
  //   updateDrop(oneDrop?._id as string, body);
  // };
  // const rejectDrop = () => {
  //   const body = { status: "declined", dropComposition: dropCompositions };
  //   // @ts-ignore
  //   updateDrop(oneDrop?._id as string, body);
  // };

  const openUserDetails = () => {
    // @ts-ignore
    navigate(`/edit-user/${oneTomraDrop?.user?._id}`);
  };

  const regroupedItems: IRegroupedTomraItems[] = useMemo(() => {
    const groupedItems = {};

    oneTomraDrop?.items.forEach((item) => {
      const superGroup = item.superGroup;

      //@ts-ignore
      if (!groupedItems[superGroup]) {
        //@ts-ignore
        groupedItems[superGroup] = {
          superGroup: superGroup,
          count: 0,
          totalRefund: 0,
        };
      }

      //@ts-ignore
      groupedItems[superGroup].count += item.count;
      //@ts-ignore
      groupedItems[superGroup].totalRefund = item.refund;
    });

    return Object.values(groupedItems);
  }, [oneTomraDrop?.items]);

  const regroupedItemsByBarcode: IRegroupedTomraItems[] = useMemo(() => {
    const groupedItems = {};

    oneTomraDrop?.items.forEach((item) => {
      const barcode = item.barcode;

      //@ts-ignore
      if (!groupedItems[barcode]) {
        //@ts-ignore
        groupedItems[barcode] = {
          superGroup: item?.superGroup,
          barcode,
          count: 0,
          totalRefund: 0,
        };
      }

      //@ts-ignore
      groupedItems[barcode].count += item.count;
      //@ts-ignore
      groupedItems[barcode].totalRefund += item.refund;
    });

    return Object.values(groupedItems);
  }, [oneTomraDrop?.items]);

  return (
    <div>
      <div className="flex flex-row items-center mb-6 justify-between">
        <div className="flex flex-row items-center justify-start">
          <LeftArrow onClick={goBack} className="mr-3 cursor-pointer" />
          <h1 className="font-satoshi text-base sm:text-2xl font-bold text-dark">
            #{params?.id}
          </h1>
        </div>
        {/* <div className="flex flex-row items-center justify-end">
          <PrimaryButton onClick={approveDrop} label="Approve" />
          <OrangeButton onClick={holdDrop} className="ml-4" label="Hold" />
          <RedButton onClick={rejectDrop} className="ml-4" label="Reject" />
        </div> */}
      </div>
      <div className="w-full flex flex-row mb-6">
        <div className="w-full sm:w-2/3 min-w-fit h-fit p-7 bg-white border border-gray-border drop-shadow-md mb-[20px] flex flex-row justify-between">
          <div className="flex flex-row items-center">
            <img
              alt="profileImage"
              className="w-[60px] h-[60px] sm:w-[100px] sm:h-[100px] rounded-full object-cover mr-8"
              src={
                // @ts-ignore
                oneTomraDrop?.user?.profileImage ??
                require("../../assets/pictures/dummy/dummy-avatar.png")
              }
            />
            <p className="self-center font-satoshi text-dark font-bold text-base sm:text-xl">
              {/* @ts-ignore */}
              {oneTomraDrop?.user?.first_name} {oneTomraDrop?.user?.last_name}
            </p>
          </div>
          <div className="self-center">
            <PrimaryButton onClick={openUserDetails} label="User details" />
          </div>
        </div>
      </div>
      <div className="w-full sm:w-2/3 min-w-fit bg-white border border-gray-border drop-shadow-md mb-[20px]">
        <div className="w-full bg-gray-50 px-10 py-4 flex flex-row items-center justify-between font-satoshi text-dark font-medium text-base">
          <p>Location</p>
          <p>Earnings</p>
        </div>
        <div className="w-full bg-white px-10 py-4 flex flex-row items-center justify-between font-satoshi text-dark font-normal text-base">
          <p>{oneTomraDrop?.metadata?.location?.name}</p>
          <p>{Number(totalPrice ? totalPrice / 100 : 0)?.toFixed(2)} €</p>
        </div>
      </div>
      <div className="w-full sm:w-2/3 min-w-fit bg-white border border-gray-border drop-shadow-md mb-[20px]">
        <div className="w-full border-b border-gray-border px-[28px] py-[15px]">
          <p className="font-satoshi font-medium text-base text-dark">
            Items grouped by type
          </p>
        </div>
        <div className="w-full bg-gray-50 px-10 py-4 flex flex-row items-center justify-between font-satoshi text-dark font-medium text-base">
          <p className="flex flex-row items-center justify-start flex-1">
            Item type
          </p>
          <p className="flex flex-row items-center justify-center flex-1">
            Count
          </p>
          <p className="flex flex-row items-center justify-end flex-1">
            Total Amount
          </p>
        </div>
        {regroupedItems?.map((item, index) => {
          return (
            <div
              key={String(index)}
              className="w-full bg-white px-10 py-4 flex flex-row items-center justify-between font-satoshi text-dark font-normal text-base"
            >
              <div className="flex flex-row items-center justify-start flex-1">
                <img
                  alt="tomraIcon"
                  className="w-[40px] h-[40px] object-contain mr-8"
                  src={tomraCanTypes?.[item?.superGroup]?.icon ?? undefined}
                />
                <p>{tomraCanTypes?.[item?.superGroup]?.label ?? "Unknown"}</p>
              </div>
              <p className="flex flex-row items-center justify-center flex-1">
                {item?.count}{" "}
              </p>
              <p className="flex flex-row items-center justify-end flex-1">
                {item?.totalRefund
                  ? Number((item?.totalRefund * item.count) / 1000)?.toFixed(2)
                  : 0}{" "}
                €
              </p>
            </div>
          );
        })}
      </div>
      <div className="w-full min-w-fit bg-white border border-gray-border drop-shadow-md mb-[20px]">
        <div className="w-full border-b border-gray-border px-[28px] py-[15px]">
          <p className="font-satoshi font-medium text-base text-dark">
            Items grouped by barcode
          </p>
        </div>
        <div className="w-full bg-gray-50 px-10 py-4 flex flex-row items-center justify-between font-satoshi text-dark font-medium text-base">
          <p className="flex flex-row items-center justify-start flex-1">
            Item type
          </p>
          <p className="flex flex-row items-center justify-center flex-1">
            Item name
          </p>
          <p className="hidden sm:table-cell flex-row items-center justify-center sm:flex-1">
            Barcode
          </p>
          <p className="flex flex-row items-center justify-center flex-1">
            Count
          </p>
          <p className="flex flex-row items-center justify-end flex-1">
            Total Amount
          </p>
        </div>
        {regroupedItemsByBarcode?.map((item, index) => {
          const productName = statiegeldProducts?.find(
            (product) => product?.gtin === item?.barcode
          );
          return (
            <div
              key={String(index)}
              onClick={() =>
                navigate(
                  `/statiegeld-product-users-list/barcode/${item?.barcode}`
                )
              }
              className="w-full bg-white hover:bg-gray-100 px-10 py-4 flex flex-row items-center justify-between font-satoshi text-dark font-normal text-base cursor-pointer"
            >
              <div className="flex flex-row items-center justify-start flex-1">
                <img
                  alt="tomraIcon"
                  className="w-[30px] h-[30px] sm:w-[40px] sm:h-[40px] object-contain mr-2 sm:mr-8"
                  src={tomraCanTypes?.[item?.superGroup]?.icon ?? undefined}
                />
                <p>{tomraCanTypes?.[item?.superGroup]?.label ?? "Unknown"}</p>
              </div>
              <p className="flex flex-row items-center justify-center flex-1">
                {productName?.name ?? ""}
              </p>
              <p className="hidden sm:table-cell flex-row items-center justify-center sm:flex-1">
                {item?.barcode}
              </p>
              <p className="flex flex-row items-center justify-center flex-1">
                {item?.count}{" "}
              </p>
              <p className="flex flex-row items-center justify-end flex-1">
                {item?.totalRefund
                  ? Number((item?.totalRefund * item?.count) / 1000)?.toFixed(2)
                  : 0}{" "}
                €
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default withProtectedRoute(TomraDropDetailsScreen);
